import { toDayKey } from './day-key.js';
import { getTripTiming } from './trip-timing.js';

/** Default map filter: today during active trip, otherwise first itinerary day. */
export function resolveDefaultMapDayKey(ctx) {
  if (!ctx?.days?.length) return null;

  const timing = getTripTiming(ctx.trip);
  if (timing?.phase === 'active') {
    const todayInTrip = ctx.days.some((d) => toDayKey(d.date) === timing.todayKey);
    if (todayInTrip) return timing.todayKey;
  }

  return toDayKey(ctx.days[0].date);
}

/** Route segment `all` means show every day; bare `/map` should redirect to default day. */
export function normalizeMapDayKey(mapDayKey) {
  if (!mapDayKey || mapDayKey === 'all') return null;
  return mapDayKey;
}
